<template>
    <div class="box-warp" v-loading="loading">
        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
            <el-menu-item index="0">退费中</el-menu-item>
            <el-menu-item index="1">退费完成</el-menu-item>
        </el-menu>
        <div class="content-warp">
            <el-form inline ref="form" :model="searchFrom" label-width="80px">
                <el-form-item>
                    <el-input v-model="searchFrom.orderNumber" placeholder="挂号单号/收费单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchFrom.patientName" placeholder="患者姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchFrom.phone" placeholder="手机号码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker value-format="yyyy-MM-dd" v-model="searchFrom.date" type="daterange" range-separator="至"
                        start-placeholder="开始月份" end-placeholder="结束月份">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <customTable @pageChange="pageChange" class="customTable" :tableData="tableData" :column="column" :total="total"
                :currentPage="searchFrom.pageNum" :header-cell-style="{ background: '#F0F1F3' }">
                <template slot="expand" slot-scope="row">
                    <customTable :showPages="false" :border="true" :column="detailColumn" :tableData="row.row.detailList">
                        <template slot="refundWay" slot-scope="detailRow">{{ detailRow.row.refundWay | filterPayWay(PAY_WAY)
                        }}{{ detailRow.row.isMutualAidPay ? '共济' : '' }}</template>
                        <template slot="action" slot-scope="detailRow">
                            <el-button @click="refunfAgain(row.row, detailRow.row)" type="text"
                                :disabled="detailRow.row.status == '5' && detailRow.row.refundWay == '1' || (detailRow.row.status != '7' && detailRow.row.status != '1'   && detailRow.row.refundWay != '1')">重新退费</el-button>
                            <el-button type="text" @click="changeRefundWay(row.row, detailRow.row)"
                                :disabled="detailRow.row.status != '7' || detailRow.row.refundWay == '1'">更换退费方式</el-button>
                        </template>
                    </customTable>
                </template>
                <template slot="action1" slot-scope="row">
                    <el-button type="text" @click="checkDetail(row.row.id)">查看详情</el-button>
                </template>
                <template slot="status" slot-scope="row">
                    <div class="status" :style="{ color: row.row.status == '3' ? '#1890FF' : '#29C01B' }"> {{ row.row.status
                        |
                        filterStatus }}</div>
                </template>
            </customTable>
        </div>
        <!-- 弹框 -->
        <div>
            <div v-for="item in levelData" :key="item.name">
                <div v-if="visibleObj[item.name]">
                    <component :is="item.dialog" v-if="visibleObj[item.name]" :ref="item.ref" :visibleObj="visibleObj"
                        @close="dialogVisible" @updateData="confirmUpdateData" :dialogObj="dialogObj">
                    </component>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { payDTO, CommonDTO } from '@/DTO/index.js'
import { dictText, isNull, isEmptyArray } from '@/utils/validateBase'
import { PAY_WAY, refundStatusList } from '@/utils/const'
import { Utils } from '@/utils/utils'
import refunDetailDialog from '../components/refunDetailDialog'
import { levelData, visibleObj } from '@/components/js/dialog'
import chargeRefundDialog from '../components/chargeRefundDialog.vue'
import { querySettlementInfo, ybCancelSettlement, handleRefundSetlinfo,ybGjCancelSettlement } from '@/utils/yibaoTools'
export default {
    // 定义引入的组件
    components: { customTable, refunDetailDialog, chargeRefundDialog },
    props: {},
    data() {
        return {
            loading: false,
            PAY_WAY: [],
            searchFrom: {
                deptId: this.$session.get('deptId'),
                pageSize: 10,
                pageNum: 1,
                orderNumber: '',
                patientName: '',
                phone: '',
                startTime: '',
                stopTime: '',
                date: []

            },//搜索条件
            activeIndex: "0",
            total: 0,
            tableData: [{}],
            levelData: levelData,
            visibleObj: visibleObj,
            dialogObj: {},
            currentLevelData: {},//显示在最上面弹框对象信息
            column: [
                { type: 'expand', slotName: 'expand' },
                { label: "退费单号", prop: "id" },
                { label: "订单编号", prop: "orderNumber" },
                { label: "患者", prop: "patientName" },
                { label: "手机号", prop: "phone" },
                // { label: "退费方式", prop: "" },
                { label: "退费金额", prop: "amount" },
                { label: "退费原因", prop: "refundReason" },
                { label: "申请时间", prop: "createTime" },
                {
                    label: "状态", slotName: "status"
                },
                // {
                //     label: "状态", prop: "status", formatter(row) {
                //         return dictText(row.status, refundStatusList)
                //     }
                // },
                { label: "操作人", prop: "createBy" },
                { label: "操作", slotName: "action1" },
            ],
            detailColumn: [
                { label: "退费方式", slotName: "refundWay" },
                { label: "退费金额", prop: "amount" },
                {
                    label: "申请时间", prop: "createTime", formatter(row) {
                        return Utils.timeFormat(row.createTime, 'yyyy-MM-DD HH:mm:ss')
                    }
                },
                {
                    label: "状态", prop: "status", formatter(row) {
                        return dictText(row.status, refundStatusList)
                    }
                },
                { label: "操作人", prop: "createBy" },
                { label: "操作", slotName: "action" },
            ],

        }
    },
    //变量监听
    watch: {},
    filters: {
        filterStatus(val) {
            return dictText(val, refundStatusList)
        },
        filterPayWay(val, PAY_WAY) {
            return dictText(val, PAY_WAY)
        },
    },
    // 页面初始化
    async created() {
        this.PAY_WAY = await CommonDTO.getPayWay()
        this.queryRefundTaskList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {

        /**
         * 更换退费方式
         */
        async changeRefundWay(row, itemRow) {
            let { code, data } = await payDTO.getRefundItemOld({ orderId: row.orderId, orderType: row.orderType })
            if (code == 200) {
              let record = !isNull(data.record) && !isEmptyArray(data.record) ? data.record.filter(item => { return item.payWay != 1 }) : []
              this.dialogObj.orderId = row.orderId
              this.dialogObj.record = record
              this.dialogObj.refundTotal = itemRow.amount
              this.dialogObj.resource = 1
              this.dialogObj.taskDetalId = itemRow.id
              this.dialogObj.isStandby = row.isStandby
              this.dialogVisible('chargeRefundDialog', true)
            }
        },

        /**
         * 退款重试
         */
        refunfAgain(row, detailRow) {
            this.loading = true
            if (detailRow.refundWay == '1') {
                this.handleYBRefunfAgain(row, detailRow)
            } else {
                this.handleRefunfAgain(detailRow)
            }
        },

        /**
         * 执行医保重试退款
         */
        handleYBRefunfAgain(row, detailRow) {
            // 医保
            querySettlementInfo(detailRow, this).then(res => {
                payDTO.refundRetry({ refundTaskDetailId: detailRow.id, deptId: this.$session.get('deptId'), attach: {} }).then(async retryRes => {
                    if (retryRes.code == 200) {
                        let time = await CommonDTO.getSystemTimeDTO()
                        let obj = {
                            refundNumber: retryRes.data.refundNumber,
                            amount: detailRow.amount,
                            refundTime: this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
                            reason: row.refundReason,
                            attach: {}
                        }
                        if (res.code == 200) {
                            let flag = res.data.setlinfo.refd_setl_flag
                            if (flag == 1) {
                                //医保已退款
                                obj.refundStatus = '1'
                                this.refundSuccess(obj)
                            } else {
                                // 重新进行医保退款
                                let ybRes = detailRow.isMutualAidPay ? await ybGjCancelSettlement(detailRow, this) : await ybCancelSettlement(detailRow, this)
                                if (ybRes.code == 200) {
                                    obj.attach = handleRefundSetlinfo(detailRow.isMutualAidPay ? ybRes.data.result : ybRes.data.setlinfo).setlinfoObj
                                    obj.refundStatus = '1'
                                    this.refundSuccess(obj)
                                } else {
                                    obj.refundStatus = '2'
                                    this.refundSuccess(obj)
                                }
                            }
                        } else {
                          if(res.msg.includes('该结算信息已回退')){
                            obj.refundStatus = '1'
                            this.refundSuccess(obj)
                          }else{
                            this.loading = false
                          }
                        }
                    } else {
                        this.loading = false
                    }
                }).catch(err => {
                    this.loading = false
                })

            }).catch(err => {
                this.loading = false
            })
        },

        /**
         * 退款完成
         */
        refundSuccess(obj) {
            payDTO.refundCallback(obj).then(res => {
                if (res.code == 200) {
                    this.loading = false
                    if (obj.refundStatus == 1) this.$message.success('退款成功');
                    this.queryRefundTaskList()
                } else {
                    this.loading = false
                    this.$message.error('退款失败，请重试')
                }
            }).catch(err => {
                this.loading = false
                this.$message.error('退款失败，请重试')
            })
        },

        /**
         * 执行非退款重试
         */
        handleRefunfAgain(row) {
            payDTO.refundRetry({ refundTaskDetailId: row.id, deptId: this.$session.get('deptId') }).then(res => {
                let { code, data } = res
                if (code == 200) {
                    this.loading = false
                    payDTO.refund({ refundNumber: data.refundNumber }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('重试成功')
                        }
                        this.queryRefundTaskList()
                    })
                } else {
                    this.queryRefundTaskList()
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })

        },

        /**
         * 查看详情
         */
        checkDetail(id) {
            this.dialogObj.refundTaskId = id
            this.dialogVisible('refunDetailDialog', true)
        },
        /**
         * 
         */
        handleSelect(val) {
            this.activeIndex = val
            this.queryRefundTaskList()
        },
        /**
         * 
         */
        search() {
            this.searchFrom.pageNum = 1
            this.queryRefundTaskList()
        },
        /**
         * 
         */
        pageChange(obj) {
            let { current, size } = obj
            this.searchFrom.pageNum = current
            this.searchFrom.pageSize = size
            this.queryRefundTaskList()
        },
        /**
         * 查询退款列表
         */
        async queryRefundTaskList() {
            let obj = {
                ...this.searchFrom,
                startTime: isNull(this.searchFrom.date) ? '' : this.searchFrom.date[0],
                stopTime: isNull(this.searchFrom.date) ? '' : this.searchFrom.date[1],
                detailStatus: this.activeIndex == '0' ? ['1', '3', '7'] : ['5']
            }
            let { code, rows, total } = await payDTO.queryRefundTaskList(obj)
            if (code == 200) {
                this.tableData = rows
                this.total = total
            }
        },
        /**
        * 关闭弹框
        */
        dialogVisible(name, bol) {
            let visibleObj = this.visibleObj;
            name = name || this.currentLevelData.name;
            visibleObj[name] = bol != undefined ? bol : !visibleObj[name];
            this.$set(this, "visibleObj", visibleObj);
            this.setDialogLevel(name)
            this.getLevelData(name);
        },
        /**
        * 弹框确认
         */
        confirmUpdateData(data) {
            let currentLevelData = this.currentLevelData;
            currentLevelData.confirmfn && this[currentLevelData.confirmfn](data);
        },
        // 设置弹窗层级
        setDialogLevel(currentLevel) {
            let visibleObj = this.visibleObj;
            let levelData = this.levelData;
            let that = this;
            if (this.visibleObj[currentLevel]) {
                levelData.map(v => {
                    // 设置当前层的level为1，其余visible为true的level依次递增
                    // enter confirm操作的始终是level为1的dialog
                    if (v.name == currentLevel) {
                        v.level = 1
                    } else if (that.visibleObj[v.name]) {
                        v.level = Utils.bigNumber(v.level, '+', 1)
                    }
                })
            } else {
                levelData.map(v => {
                    // 当前dialog关闭，则设置level为0， 其余visible为true的level依次减一
                    if (v.name == currentLevel) {
                        v.level = 0
                    } else if (that.visibleObj[v.name] && Utils.gt(v.level, 0)) {
                        v.level = Utils.bigNumber(v.level, '-', 1)
                    }
                })
            }

            this.$set(this, 'levelData', levelData)
        },
        // 获取当前层级 及其Data
        getLevelData(name) {
            let visibleObj = this.visibleObj;
            let levelData = this.levelData;
            let obj = {};
            let currentLevelData = levelData.filter(v => {
                return v.level == 1
            });
            obj = {
                ...currentLevelData[0],
            }
            this.$set(this, 'visibleObj', visibleObj)
            this.$set(this, 'currentLevelData', obj)
        },
        /**
        * 退款完成
        */
        chargeRefundDialogConfirm() {
            this.dialogVisible('chargeRefundDialog', false);
            this.queryRefundTaskList()
        },
    },
}
</script>
<style lang="less" scoped src="./refundList.less"></style>